package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.MoveResize: ImageVector
    get() {
        if (_moveResize != null) {
            return _moveResize!!
        }
        _moveResize = Builder(name = "MoveResize", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
                viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(4.5f, 2.0f)
                    curveTo(3.112f, 2.0f, 2.0f, 3.112f, 2.0f, 4.5f)
                    lineTo(2.0f, 19.5f)
                    curveTo(2.0f, 20.888f, 3.112f, 22.0f, 4.5f, 22.0f)
                    lineTo(19.5f, 22.0f)
                    curveTo(20.888f, 22.0f, 22.0f, 20.888f, 22.0f, 19.5f)
                    lineTo(22.0f, 4.5f)
                    curveTo(22.0f, 3.112f, 20.888f, 2.0f, 19.5f, 2.0f)
                    moveTo(4.5f, 4.5f)
                    lineTo(19.5f, 4.5f)
                    lineTo(19.5f, 19.5f)
                    lineTo(4.5f, 19.5f)
                    moveTo(10.75f, 5.75f)
                    lineTo(10.75f, 7.0f)
                    lineTo(12.0f, 7.0f)
                    lineTo(12.0f, 13.25f)
                    lineTo(7.0f, 13.25f)
                    lineTo(7.0f, 12.0f)
                    lineTo(5.75f, 12.0f)
                    lineTo(5.75f, 15.75f)
                    lineTo(7.0f, 15.75f)
                    lineTo(7.0f, 14.5f)
                    lineTo(12.0f, 14.5f)
                    lineTo(12.0f, 17.0f)
                    lineTo(10.75f, 17.0f)
                    lineTo(10.75f, 18.25f)
                    lineTo(14.5f, 18.25f)
                    lineTo(14.5f, 17.0f)
                    lineTo(13.25f, 17.0f)
                    lineTo(13.25f, 14.5f)
                    lineTo(17.0f, 14.5f)
                    lineTo(17.0f, 15.75f)
                    lineTo(18.25f, 15.75f)
                    lineTo(18.25f, 12.0f)
                    lineTo(17.0f, 12.0f)
                    lineTo(17.0f, 13.25f)
                    lineTo(13.25f, 13.25f)
                    lineTo(13.25f, 7.0f)
                    lineTo(14.5f, 7.0f)
                    lineTo(14.5f, 5.75f)
                }
            }
        }
        .build()
        return _moveResize!!
    }

private var _moveResize: ImageVector? = null
